import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import './instrument';
import App from "./App.tsx";
import BackupService from "./services/BackupService";

// Initialize backup service
BackupService.initialize().catch((error) => {
  console.error("Failed to initialize backup service:", error);
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
